import React from "react";
import PropTypes from "prop-types";
import { Card, CardSection } from "cxa-components";

const Step = ({ num, activeIndex, children }) => {
  const isActive = num == activeIndex;
  const isCompleted = num < activeIndex;
  const className = `step-item ${isActive ? "active-step" : isCompleted && "completed-step"}`;
  return (
    <div className={className}>
      {num > 1 && (
        <div className="step-connector">
          <span className="connector-line"></span>
        </div>
      )}
      <span className="step-content">
        <button className={`step-btn`}>{num}</button>
        <span className="step-name">
          {num == activeIndex && <strong>{children}</strong>}
          {num !== activeIndex && children}
        </span>
      </span>
    </div>
  );
};

const HDFStepper = ({ index, steps }) => {
  return (
    <Card className="hdf-card">
      <CardSection>
        <div className="step-container hdf-stepper">
          {steps &&
            steps.length > 0 &&
            steps.map(({ pageName }, idx) => {
              return (
                <Step key={pageName} num={idx + 1} activeIndex={index || 1}>
                  {pageName}
                </Step>
              );
            })}
        </div>
      </CardSection>
    </Card>
  );
};

HDFStepper.propTypes = {
  steps: PropTypes.array.isRequired,
  index: PropTypes.number,
};
Step.propTypes = {
  children: PropTypes.string || PropTypes.object,
  num: PropTypes.number,
  activeIndex: PropTypes.number,
};

export default HDFStepper;



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/Stepper.js